var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marker-red",
    width: "25px",
    height: "36px",
    viewBox: "0 0 25 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin icon copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-red-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-red-2",
    transform: "translate(-14.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-red-3",
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "marker-red-4",
    d: "M12.5,1 C9.32436269,1 6.44936269,2.28718134 4.36827202,4.36827202 C2.28718134,6.44936269 1,9.32436269 1,12.5 C1,18.1984224 9.78963067,30.1221593 12.4999098,33.6633882 C15.2091008,30.1238802 24,18.1988336 24,12.5 C24,9.32436269 22.7128187,6.44936269 20.631728,4.36827202 C18.5506373,2.28718134 15.6756373,1 12.5,1 Z",
    stroke: "#151515",
    strokeWidth: 2,
    fill: "#E60400"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "marker-red-5",
    fill: "#151515",
    cx: 12.5,
    cy: 11.7647059,
    r: 4.41176471
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRed);
export default __webpack_public_path__ + "static/media/marker-red.89ce6815b86d29b307f70ea4c0ccfcaf.svg";
export { ForwardRef as ReactComponent };